{
  "Clear search": "Effacer la recherche"
}
